import { Link } from "react-router-dom";
import classes from "./BackBtn.module.css";
import backArrow from "../../../images/backArrow.svg";

export function BackBtn({ to, onClick }) {
  return (
    <Link to={to} className={classes.btn} onClick={onClick}>
      <img src={backArrow} alt="" />
    </Link>
  );
}
